import React from 'react'
import { observer } from 'mobx-react'
import Button from 'components/Button'
import styles from './WorkpapersFooter.sass'
import WorkpapersViewModel from '../WorkpapersViewModel'

interface Props {
  onButtonClick: (moveForward: boolean) => void
  selectedWorkpaper: WorkpapersViewModel
}

export default observer(function WorkpapersFooter({
  onButtonClick,
  selectedWorkpaper,
}: Props) {
  const moveForward = true

  return (
    <div className={styles.footer}>
      <Button
        onClick={() => onButtonClick(!moveForward)}
        dataTest="workpaper-footer-previous-button"
      >
        Previous
      </Button>

      <Button
        className={styles.next}
        onClick={() => onButtonClick(moveForward)}
        dataTest="workpaper-footer-next-button"
      >
        Next
      </Button>

      <Button
        type="primary"
        disabled={!selectedWorkpaper.hasValidFields}
        onClick={() => selectedWorkpaper.validateFields()}
        dataTest="workpaper-validate"
        loading={selectedWorkpaper.validateFields.pending}
      >
        Save
      </Button>
    </div>
  )
})
